import { darken } from 'polished';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../../../../../components/Button';

export const Wrapper = styled.div`
  padding: 15px 0 30px 0;
`;

export const PageTitle = styled.h1`
  font-weight: 700;
  font-size: 24px;
  color: #263238;

  margin-top: 10px;
  margin-bottom: -15px;

  &.main__title {
    margin-bottom: 15px;
  }
`;

export const PageSubtitle = styled.h1`
  font-weight: 700;
  font-size: 18px;
  color: #263238;

  margin-top: 10px;
  margin-bottom: -15px;
`;

export const InputWrapper = styled.div`
  margin-bottom: -5px;

  > span:first-child,
  > label:first-child {
    display: block;
    padding-left: 5px;
    margin-bottom: 7px;

    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
  }

  div.numero_empresa {
    padding-left: 5px;
    display: flex;
    color: #717171;

    span {
      font-weight: bold;
      font-size: 14px;
      display: block;
    }

    p {
      margin-left: 10px;
    }
  }
`;

export const DeliveryFeeContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-end;
  padding-block: 20px;
  width: 100%;
  max-width: 680px;
  & > div {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
    label {
      font-family: 'Sora', sans-serif;
      font-size: 13px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.black};
    }
    input {
      background-color: ${({ theme }) => theme.colors.white};
      border: 2px solid ${({ theme }) => theme.colors.lightGrey};
      border-radius: 5px;
      padding: 13px 15px;
      font-family: 'Sora', sans-serif;
      font-size: 13px;
      color: ${({ theme }) => theme.colors.black};
      width: 100%;
      transition: all 0.2s ease;
      &:focus {
        border-color: ${({ theme }) => theme.colors.main};
      }
    }
  }
  & > button {
    height: 46px;
    width: 46px;
    border-radius: 5px;

    div {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      svg {
        color: inherit;
      }
    }
  }
  & + div {
    border-top: 1px solid rgba(124, 141, 181, 0.25);
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    flex-direction: column;

    & > span {
      flex-direction: column !important;
      width: 100% !important;
    }
  }
`;

export const LogotipoWrapper = styled.div`
  position: relative;
  width: 186px;
  margin-top: 5px;
  margin-bottom: 15px;

  img {
    border-radius: 50%;
    width: 186px;
    height: 186px;

    border: 2px solid #fff;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.35);
  }

  label {
    position: absolute;
    right: 6px;
    bottom: 6px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 42px;
    height: 42px;

    border-radius: 21px;
    border: none;
    color: #fefefe;
    background: #2979ff;
    cursor: pointer;

    transition: background 0.25s ease-in-out;

    &:hover {
      background: ${darken(0.075, '#2979ff')};
    }

    input {
      display: none;
    }
  }
`;

export const ButtonStyled = styled(Button)`
  margin-top: 10px;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const PasswordActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  width: 100%;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: auto !important;
    min-width: 0;
    margin-top: 0;
    padding: 0 20px;
    white-space: nowrap;
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    flex-wrap: wrap;

    button {
      width: 100% !important;
    }
  }
`;

export const PasswordFormActions = styled(PasswordActions)`
  justify-content: center;

  button {
    flex: 1 1 0;
    width: 100% !important;
  }
`;

export const PasswordSummary = styled.div`
  padding: 8px 0;

  strong {
    color: #263238;
    font-size: 15px;
    font-weight: 600;
  }

  span {
    margin-bottom: 0;
  }
`;

export const InformativeSpan = styled.span`
  display: block;
  margin: 15px 0;
  color: #757575;
  font-size: 14px;
  font-weight: 300;
`;

export const LittleInformativeSpan = styled.span`
  display: block;
  color: #757575;
  font-size: 12px;
  margin-top: 5px;
`;

export const Subtitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  color: #263238;
  margin-top: 5px;
`;

export const DividerStyled = styled.div`
  margin: 7px 5px -15px 5px;
  padding: 0 20px;
  border-bottom: 1px solid #f5f5f5;
`;

export const SectionDivider = styled.div`
  position: relative;

  h1 {
    font-weight: 700;
    font-size: 20px;
    color: #263238;

    margin-top: 5px;
  }
`;

export const AnchorLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 10px;
  padding: 7px 5px;

  border-radius: 16px;
  background-color: #003399;
  transition: all 0.2s ease-in-out;

  text-decoration: none;
  font-weight: 700;
  color: #fff;
  font-size: 16px;

  svg {
    color: #fff;
    margin-bottom: 2px;
    margin-right: 12px;
  }

  &:hover {
    background-color: ${darken(0.05, '#003399')};
  }
`;

export const CellWrapper = styled.div`
  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 38px;
    width: 38px;

    background: transparent;
    border-radius: 50%;
    transition: all 0.25s ease-in-out;

    color: #ef6c00;

    &:hover {
      background: rgba(239, 108, 0, 0.05);
      color: ${darken(0.025, '#ef6c00')};
    }
  }
`;

export const AddButton = styled.button`
  position: relative;

  border: none;
  background: none;
  margin-top: 10px;

  font-size: 15px;
  font-weight: 500;
  color: #1976d2;

  transition: all 0.35s ease-in-out;

  &:hover {
    color: #1565c0;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -1px;

    height: 1px;
    width: 0;

    background: #1565c0;

    transition: width 0.35s ease-in-out;
  }

  &:hover::after {
    width: 100%;
  }
`;

export const Input = styled.input`
  max-width: 62px;
  height: 27px;

  text-align: center;

  border-radius: 4px;
  border: 1px solid #9e9e9e;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const FormWrapper = styled.div`
  padding: 0 15px;
`;

export const FormItemWrapper = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 20px;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin-right: 40px;

    span {
      font-weight: 500;
      margin-bottom: 7px;
    }
  }
`;

export const TrashBtnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  height: 100%;

  button {
    background: transparent;

    border: none;
    color: #424242;
    margin-bottom: 7px;

    transition: all 0.35s ease-in-out;

    &:hover {
      color: #d32f2f;
    }
  }
`;

export const ModalWrapper = styled.div`
  width: 280px;
  background: #fff;
  border-radius: 6px;
  padding: 20px;

  div.header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-bottom: 30px;

    > h1 {
      font-size: 26px;
      color: #212121;
    }

    > button {
      position: relative;
      background: transparent;
      border: none;
      color: #d32f2f;
      padding: 5px;
      border-radius: 15px;
      transition: all 0.35s ease-in-out;

      &:hover {
        color: #b71c1c;
        transform: scale(1.125);
      }
    }
  }

  div.description {
    margin-bottom: 30px;
    font-size: 15px;
  }

  div.btnActions {
    button {
      display: block;
      height: 35px;
      width: 100%;
      border-radius: 4px;

      margin-bottom: 7px;

      font-size: 14px;
      font-weight: 500;
      border: none;
      transition: all 0.35s ease-in-out;

      &.confirm {
        background: #1565c0;
        color: #fff;

        &:hover {
          background: #0d47a1;
        }

        &:disabled {
          border: 1px solid #757575;
          color: #757575;
          background: #f5f5f5 !important;
          cursor: not-allowed;
        }
      }

      &.cancel {
        border: 1px solid #1565c0;
        background: #fff;
        color: #1565c0;

        &:hover {
          color: #0d47a1;
          border: 1px solid #0d47a1;
        }
      }
    }
  }

  div.suggestions {
    display: grid;
    gap: 15px;
    grid-template-columns: repeat(auto-fit, 150px);
  }
`;

export const InputURLContainer = styled.div`
  width: 100%;

  > span:first-child {
    display: block;
    padding-left: 5px;
    margin-bottom: 7px;
    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
  }

  div {
    display: flex;
    border-radius: 8px;
    border: 1px solid #9e9e9e;
    overflow: hidden;

    span {
      display: block;
      padding: 10px;
      border-radius: 8px 0 0 8px;
      background-color: #eee;
    }

    input {
      flex: 1;
      border: none;
      background-color: #ffffff;
      padding: 0 10px;
    }
  }
`;

export const ContainerBanner = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentBanner = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 30px;
  background: #fff;
  border-radius: 4px;

  border: 1px solid #9e9e9e;
  padding: 10px;
  margin: 15px 0px;
`;

export const InfoBanner = styled.div`
  ul {
    padding: 0px 18px;
  }
  p,
  li {
    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
  }
  p {
    margin-bottom: 8px;
  }
  li {
    list-style-type: disclosure-closed;
  }
`;

export const SemBannerTitle = styled.div`
  p {
    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
    margin-left: 12px;
  }
`;

export const ButtonSaveBanner = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;

  button {
    padding: 5px 8px;
    border-radius: 5px;
    border: 1px solid transparent;
    background-color: #329bfc;
    color: #fff;

    :hover {
      opacity: 0.8;
    }
  }
`;
